var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        window.hSelect = require('../../../include/h-select/_js/h-select');
    }, { "../../../include/h-select/_js/h-select": 2 }], 2: [function (require, module, exports) {
        function hSelect(params) {

            this.element = $(params.selector).length > 0 ? $(params.selector) : null;
            if (!this.element) return;
            this.id = this.element.prop('id');
            if (this.id == '') {
                this.id = 'hSelect' + Math.floor(Math.random() * 10001);
                this.element.prop('id', this.id);
            }
            this.$facewrap = this.element.find('.h-select-face-wrap');
            this.$face = this.element.find('.h-select-face');
            this.$items = this.element.find('.h-select-items');
            this.value = this.$face.data('value');

            this.theme = (params.theme || 'default') + '_hSelect';
            this.element.addClass(this.theme);
            this.checkWidth = 'checkWidth' in params ? params.checkWidth : true;
            this.checkHeight = 'checkHeight' in params ? params.checkWidth : true;
            this.delta = 'delta' in params ? params.delta : 0;

            this.dynamicItems = 'dynamicItems' in params ? params.dynamicItems : false;
            this.onShowItem = 'onShowItem' in params ? params.onShowItem : null;
            this.onBodyClick = 'onBodyClick' in params ? params.onBodyClick : null;
            this.preventDefault = 'preventDefault' in params ? params.preventDefault : true;
            this.forwarding = 'forwarding' in params ? params.forwarding : false;
            this.userItemClick = 'onItemClick' in params ? params.onItemClick : null;
            this.userOnFaceClick = 'onFaceClick' in params ? params.onFaceClick : null;
            this.userItemMouseEnter = 'onItemMouseEnter' in params ? params.onItemMouseEnter : null;
            this.userItemMouseLeave = 'onItemMouseLeave' in params ? params.onItemMouseLeave : null;

            this.showOn = 'showOn' in params ? params.showOn : 'mouse';
            this.itemsType = 'itemsType' in params ? params.itemsType : 'items'; //items - содержит обычные h-select-item, container - внутри что-то другое

            this.handleOnChange = params.onChange || null;
            this.handlers();

            //return this.element;
        }

        hSelect.prototype.handlers = function () {
            var that = this;
            $(document).ready(function () {

                that.$items.on('mouseenter', '.h-select-item', function (e) {
                    e.preventDefault();
                    //that.onItemMouseEnter($(this));
                    if ('function' == typeof that.userItemMouseEnter) that.userItemMouseEnter($(this));else that.onItemMouseEnter($(this));
                });
                that.$items.on('mouseleave', '.h-select-item', function (e) {
                    e.preventDefault();
                    //that.onItemMouseLeave($(this));
                    if ('function' == typeof that.userItemMouseLeave) that.userItemMouseLeave($(this));else that.onItemMouseLeave($(this));
                });
                that.$items.on('mouseenter', function (e) {
                    e.preventDefault();
                    $(this).addClass('h-select-items__hovered');
                });
                that.$items.on('mouseleave', function (e) {
                    e.preventDefault();
                    $(this).removeClass('h-select-items__hovered');
                });

                var ev = 'mouse' == that.showOn ? 'mousedown' : 'click';
                that.$facewrap.on(ev, function (e) {
                    e.preventDefault();
                    if ('function' == typeof that.userOnFaceClick) that.userOnFaceClick(e);else that.onFaceClick(e);
                });
                var ev = 'mouse' == that.showOn ? 'mouseup' : 'click';
                that.$items.on(ev, '.h-select-item', function (e) {
                    if ('function' == typeof that.userItemClick) that.userItemClick($(this));else {
                        if (that.preventDefault) {
                            e.preventDefault();
                        } else if (that.forwarding) {
                            window.location = $(this).find('a').prop('href');
                        }
                        that.onItemClick($($(this)));
                    }
                    /*
                    if(that.preventDefault){
                        e.preventDefault();
                    }else if(that.forwarding){
                        //$(this).find('a').click();
                        window.location = $(this).find('a').prop('href');
                    }
                    that.onItemClick($($(this)));
                    */
                });
                //--
                /*
                that.$facewrap.on('click', function(e){
                    e.preventDefault();
                    that.onFaceClick();
                })
                that.$items.on('click', '.h-select-item', function(e){
                    if(that.preventDefault) e.preventDefault();
                    that.onItemClick($($(this)));
                });
                */
                $('body').on('click', function (e) {
                    //if($(e.target).closest('#'+that.id+' .h-select-face-wrap').length!=0) return;
                    if (0 != $(e.target).closest('#' + that.id).length || $(e.target).prop('id') == that.id) return;
                    if ('function' == typeof that.onBodyClick && !that.onBodyClick(e)) return;
                    if (0 == $(e.target).closest('#' + that.id + " .h-select-items").length) that.hide();
                });
            });
        };

        hSelect.prototype.onChange = function (value, view, $elem) {
            this.value = value;
            this.$face.data('value', value);
            this.$face.html(view);
            if (typeof this.handleOnChange == 'function') {
                this.handleOnChange(this, view, $elem);
            }
        };

        hSelect.prototype.onFaceClick = function (e) {
            this.toggle(e);
        };

        hSelect.prototype.onItemClick = function ($elem) {
            var val = $elem.data('value');
            if (val !== this.value) {
                var view = $elem.html();
                if ("undefined" != typeof $elem.data('text') && "" != $elem.data('text')) {
                    view = $elem.data('text');
                }
                this.$items.find('.h-select-item__active').removeClass('h-select-item__active');
                $elem.addClass('h-select-item__active');
                this.onChange(val, view, $elem);
            }
            this.hide();
        };

        hSelect.prototype.onItemMouseEnter = function ($elem) {
            $elem.addClass('h-select-item__hovered');
        };

        hSelect.prototype.onItemMouseLeave = function ($elem) {
            $elem.removeClass('h-select-item__hovered');
        };

        hSelect.prototype.show = function (e) {
            if (this.checkWidth) {
                var w = this.element.width();
                this.$items.width(w + this.delta);
            }
            if (this.checkHeight) {
                var h = this.$facewrap.height() + 3; //border - 2px, зазор - 1px
                this.$items.css({ top: h + 'px' });
            }
            this.$facewrap.addClass('h-select-face-wrap__opened');
            this.element.closest('.h-select-wrap').addClass('h-select-wrap__opened');
            if (this.dynamicItems && typeof this.onShowItem == 'function') {
                this.onShowItem(this, e);
            }
            this.$items.show();
            this.element.trigger('show', [this]);
        };

        hSelect.prototype.hide = function () {
            this.$facewrap.removeClass('h-select-face-wrap__opened');
            this.element.closest('.h-select-wrap').removeClass('h-select-wrap__opened');
            this.$items.hide();
            this.element.trigger('hide', [this]);
        };

        hSelect.prototype.toggle = function (e) {
            if (this.$items.css('display') == 'block') {
                this.hide(e);
            } else {
                this.show(e);
            }
        };

        hSelect.prototype.set = function (value, fake) {
            if (value == "") {
                return;
            }
            fake = 'undefined' == typeof fake ? false : fake;
            if (fake) {
                var $elem = this.$items.find('.h-select-item[data-value=' + value + ']');
                if (0 != $elem.length) {
                    var view = $elem.html();
                    this.value = value;
                    this.$face.data('value', value);
                    this.$face.html(view);
                }
            } else {
                var ev = 'mouse' == this.showOn ? 'mouseup' : 'click';
                this.$items.find('.h-select-item[data-value=' + value + ']').trigger(ev);
            }
        };

        hSelect.prototype.setByName = function (value) {
            var ev = 'mouse' == this.showOn ? 'mouseup' : 'click';
            this.$items.find('.h-select-item').each(function () {
                if ($(this).text() == value) {
                    $(this).trigger(ev);
                    return false;
                }
            });
        };

        module.exports = hSelect;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        // глобальная блокировка модалок
        window.lockPopup = false;
        window.img_load = '<img src="/img/load.gif" alt="loading">';
        window.getMessageTemplate = function (name, message) {
            message = message || '';
            var templates = {
                loading: {
                    tpl: '<div class="alert alert-info">{{text}}</div>',
                    text: 'Пожалуйста подождите ' + window.img_load
                },
                success: {
                    tpl: '<div class="alert alert-success">' + '<button type="button" class="close">×</button>' + '{{text}}</div>',
                    text: 'Успешно'
                },
                error: {
                    tpl: '<div class="alert alert-danger">' + '<button type="button" class="close">×</button>' + '{{text}}</div>',
                    text: 'Ошибка'
                }
            };
            var text;
            var result = message;
            if (name in templates) {
                text = message || templates[name].text;
                result = templates[name].tpl.split('{{text}}').join(text);
            }
            return result;
        };

        window.initPhoneMask = function () {
            $('.phone-mask').mask('+7(999)999-99-99');
        };

        window.bs3popup = function (params) {
            var $popup = $("#bspopup");

            if ('string' == typeof params) {
                $popup.modal(params);
                return;
            }
            var url = params.hasOwnProperty('page_url') ? params.page_url : null,
                data = params.hasOwnProperty('data') ? params.data : {},
                height = params.hasOwnProperty('height') ? params.height : null,
                width = params.hasOwnProperty('width') ? params.width : null,
                content = params.hasOwnProperty('content') ? params.content : null;

            // при true - модалка требует, чтобы её не затирали, зажигает флаг window.lockPopup при показе, снимает при закрытии
            var setLock = params.hasOwnProperty('setLock') ? params.setLock : false;
            // при true - вежливая модалка, которая не вылезет, если какая-то другая уже показана в этот момент
            var getLock = params.hasOwnProperty('getLock') ? params.getLock : false;

            if (getLock && window.lockPopup) {
                return;
            }

            if (params.hasOwnProperty('hash') && params.hash) document.location.hash = params.hash;

            // callback, который будет вызван при действительном (не логическом) показе модалки
            var onAfterShow = params.hasOwnProperty('onAfterShow') ? params.onAfterShow : null;

            var $dialog = $popup.find('.modal-dialog'),
                $body = $popup.find('.modal-body'),
                $content = $popup.find('.modal-content');
            $popup.addClass('request-helper');
            $dialog.css('width', '950px');
            if (width) {
                $dialog.css('width', parseFloat(width) + 40 + 'px');
            }
            if (height) {
                $body.css('height', height + 'px');
            } else {
                $body.css('height', 'auto');
            }
            //$popup.removeClass('request-helper');
            $popup.removeClass('subscribe-close').removeClass('success-close').removeClass('request-close');
            $dialog.removeClass('transparent');
            $content.removeClass('transparent');

            if (setLock) {
                window.lockPopup = true;
            }

            $popup.one('hide.bs.modal', function (e) {
                if (setLock) {
                    window.lockPopup = false;
                }
            });

            if (url) {
                if (data.hasOwnProperty('frame') && parseInt(data['frame'])) {
                    var iframe = document.createElement('iframe');
                    iframe.id = 'htIframe';
                    iframe.style.width = '100%';
                    iframe.style.height = '0px';
                    iframe.style.display = 'none';
                    var $loader = $('<div style="text-align: center;">' + img_load + ' Подождите, идет загрузка</div>');
                    iframe.onload = function () {
                        var height;
                        var $frame = $("#htIframe");
                        $frame.css('display', 'block');
                        if (data.frameHeight) {
                            height = data.frameHeight;
                        } else {
                            var $contentWrapper = $frame.contents().find(".iframe_form");
                            if (!$contentWrapper.length) {
                                $contentWrapper = $frame.contents().find("body");
                                height = $contentWrapper.outerHeight();
                            } else {
                                height = $contentWrapper.height() + 50;
                            }
                        }
                        $frame.height(height + 'px');
                        $loader.remove();
                    };
                    $body.html(iframe);
                    $body.append($loader);
                    $popup.modal({
                        backdrop: true,
                        show: true
                    });
                    iframe.src = url;
                    if (params.transparent) $dialog.addClass('transparent');
                } else {
                    $body.html("<p class='text-center'><img src='/img/load.gif' /></p>");
                    $popup.modal({
                        backdrop: true,
                        show: true
                    });
                    $.get(url, {}, function (data) {
                        $body.html(data);
                        if (params.transparent) $dialog.addClass('transparent');
                        typeof onAfterShow === 'function' && onAfterShow();
                        window.tracking.callTrackingRefresh();
                    });
                }
            } else if (content) {
                $body.html(content);
                typeof onAfterShow === 'function' && onAfterShow();
                $popup.modal({
                    backdrop: true,
                    show: true
                });
                window.tracking.callTrackingRefresh();
            }
        };

        window.close_popup = function () {
            bs3popup('hide');
        };

        window.popup2 = function (params) {
            bs3popup(params);
        };

        window.updateElementsInViewport = function (selector) {
            var $elements = $(selector);
            if ($elements.length) {
                var $element = void 0;
                $elements.each(function () {
                    $element = $(this);
                    var tourId = 'r' + $element.closest('.main-row.visible').data('id');
                    if (window.hasOwnProperty('hotTableData') && window.hotTableData.hasOwnProperty(tourId) && window.hotTableData[tourId].values.showDiscount) {
                        $element.removeClass('hidden');
                    }
                });
            }
        };

        //работа с поисковым сервером
        var reqTimer = '';
        actID = 1;
        window.findToursEnd = {};

        window.sendReq = function (data, callback, myActID) {
            var defData = {
                city_id: window.city_id,
                calcRelations: true,
                fromDb: true,
                params: {
                    adult: "2",
                    child: "0",
                    ch1: "",
                    ch2: "",
                    //country: "2",
                    //dateFrom: "19.11.2013",
                    //dateTo: "26.11.2013",
                    //departCity: "1",
                    anyHotel: "1",
                    hotels: [],
                    nightsFrom: "7",
                    nightsTo: "14",
                    priceMin: "",
                    priceMax: "",
                    region: "",
                    stars: "",
                    operators: "",
                    cur: app.currency
                }
            };
            for (var i in data.params) {
                defData.params[i] = data.params[i];
            }for (var i in data) {
                if (i !== 'params') defData[i] = data[i];
            }if (!window.ends) window.ends = app.srcCount;
            window.rt.bind('app.tours', function (data) {
                if (actID - 1 != data.actID) {
                    return false;
                }
                var isEnd = false,
                    req_id = data.req_id;
                if (!window.firstReq_id) {
                    window.firstReq_id = req_id;
                }
                if (data.act === 'end') {
                    if (--ends == 0) {
                        isEnd = true;
                        window.findInProgress = false;
                        if (window.findToursEnd) {
                            for (var i in window.findToursEnd) {
                                window.findToursEnd[i]();
                            }
                        }
                    }
                }
                var percent = data.progress.total;
                if (callback) callback(data, percent, isEnd);
                if (window.findToursCallback) window.findToursCallback(data, percent, isEnd);
            });

            if (rt.isOnline()) {
                window.findInProgress = true;
                defData['actID'] = myActID ? myActID : actID++;
                //window.utils.cl(defData);
                rt.go('app.tours', defData);
            } else {
                clearTimeout(reqTimer);
                reqTimer = setTimeout(function () {
                    sendReq(data, callback, myActID);
                }, 500);
            }
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        window.loadGoogleMapsApi = require('../../../../include/maps/google-maps-api-loader');
    }, { "../../../../include/maps/google-maps-api-loader": 2 }], 2: [function (require, module, exports) {
        var googleMapsApiOnLoadCallbacks = [];
        var googleMapsApiLoadStarted = false;

        window.googleMapsApiOnLoad = function () {
            for (var i in googleMapsApiOnLoadCallbacks) {
                googleMapsApiOnLoadCallbacks[i]();
            }
            googleMapsApiOnLoadCallbacks = [];
        };

        // function fromLatLngToPoint(latLng, map) {
        //     const topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
        //     const bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
        //     const scale = Math.pow(2, map.getZoom());
        //     const worldPoint = map.getProjection().fromLatLngToPoint(latLng);
        //
        //     return new google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale);
        // }

        module.exports = function (callback) {
            if (callback) {
                googleMapsApiOnLoadCallbacks.push(callback);
            }
            if (!window.mapsLoaded) {
                if (!googleMapsApiLoadStarted) {
                    googleMapsApiLoadStarted = true;
                    $.getScript('https://maps.google.com/maps/api/js?key=' + window.app.googleMapApiKey + '&loading=async&sensor=false&callback=googleMapsApiOnLoad', function () {
                        window.mapsLoaded = true;
                    });
                }
            } else if (callback) {
                window.googleMapsApiOnLoad();
            }
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var BaseCitySelect = require('../../../../include/_js/city-select/BaseCitySelect');

        var CitySelect = function (_BaseCitySelect) {
            _inherits(CitySelect, _BaseCitySelect);

            function CitySelect() {
                _classCallCheck(this, CitySelect);

                /**
                 * @type {window.hSelect}
                 */
                var _this = _possibleConstructorReturn(this, (CitySelect.__proto__ || Object.getPrototypeOf(CitySelect)).call(this));

                _this.cityElement = null;
                return _this;
            }

            _createClass(CitySelect, [{
                key: "init",
                value: function init() {
                    var selfSelect = this;
                    // $mainCitySelect
                    this.cityElement = new hSelect({
                        selector: '#hSelectMainCity',
                        theme: 'main',
                        checkWidth: false,
                        onItemClick: function onItemClick($elem) {
                            var val = $elem.data('value');
                            if (val !== this.value) {
                                var view = $elem.html();
                                if ('undefined' !== typeof $elem.data('text') && '' != $elem.data('text')) {
                                    view = $elem.data('text');
                                }
                                this.$items.find('.h-select-item__active').removeClass('h-select-item__active');
                                $elem.addClass('h-select-item__active');
                                this.onChange(val, view, $elem);

                                var city = window.CityItem.findById(val);
                                $(window).trigger('onLocation', city);
                            }
                            this.hide();
                        },
                        onChange: function onChange(ui) {
                            var cityName = ui.$face.text().trim();
                            selfSelect.setCity(cityName, !selfSelect.isLocatedUser(), true);
                            $(document).trigger('widget:change-city', cityName);
                        },
                        onBodyClick: function onBodyClick($e) {
                            for (var i in $e.target.classList) {
                                if ($e.target.classList[i] === "deny") {
                                    return false;
                                }
                            }
                            return true;
                        }
                    });

                    this.attachListeners();
                    this.checkLocation();
                }
            }, {
                key: "attachListeners",
                value: function attachListeners() {
                    var _this2 = this;

                    $(window).on('onLocation', function (event, city) {
                        /** @type {window.CityItem} city */
                        if (!city.id) {
                            // если города нет в списке
                            return;
                        }
                        _this2.fitSiteToCity(city.id, false);
                        window.tracking.callTrackingRefresh();
                    });
                }

                /**
                 * @inheritDoc
                 */

            }, {
                key: "fitSiteToCity",
                value: function fitSiteToCity(cityId, onlyContacts) {
                    var city = window.CityItem.findById(cityId);
                    if (!city) {
                        return false;
                    }

                    // установка контактов
                    this.drawContacts(city.id);

                    if (onlyContacts) {
                        return;
                    }

                    // смена города в списке стран
                    $('.hot-slider .hot_fake_options .hot_fake_option[data-city=' + city.id + ']').trigger('click');

                    // смена города в главном селекте
                    this.cityElement.set(city.id, true);
                }
            }, {
                key: "onAfterSetCity",
                value: function onAfterSetCity() {
                    // const city = CityItem.getCurrent();
                }
            }, {
                key: "drawContacts",
                value: function drawContacts(cityId) {
                    if (!window.CityItem.contactExist(cityId)) {
                        return false;
                    }

                    var city = window.CityItem.findById(cityId);
                    var almatyCity = window.CityItem.getDefault();
                    console.log('drawContacts', city);

                    // TODO: check actual
                    // $('.current-city-id').data('city', city.id);
                    // $('.current-city-name').text(city.name);
                    //
                    // $('.current-city-phone').text(city.currentPhone.phone);
                    // $('.current-city-phone-link').attr('href', city.currentPhone.href);


                    var faceBookLink = city.socials.facebook ? city.socials.facebook : almatyCity.socials.facebook;
                    var instagramLink = city.socials.instagram ? city.socials.instagram : almatyCity.socials.instagram;

                    $('.facebook-link').attr('href', faceBookLink);
                    $('.instagram-link').attr('href', instagramLink);
                }
            }]);

            return CitySelect;
        }(BaseCitySelect);

        new CitySelect().init();
    }, { "../../../../include/_js/city-select/BaseCitySelect": 2 }], 2: [function (require, module, exports) {
        window.CityItem = require('./CityItem');
        var pixelTracker = require('./PixelTracker');
        var location = require('./Location');

        var BaseCitySelect = function () {
            function BaseCitySelect() {
                _classCallCheck(this, BaseCitySelect);
            }

            _createClass(BaseCitySelect, [{
                key: "init",

                /**
                 * Обработчики, геолокация
                 */
                value: function init() {}

                /**
                 * @param {number} cityId
                 * @param {boolean} onlyContacts
                 * @protected
                 */

            }, {
                key: "fitSiteToCity",
                value: function fitSiteToCity(cityId, onlyContacts) {}

                /**
                 * @return {boolean}
                 */

            }, {
                key: "isLocatedUser",
                value: function isLocatedUser() {
                    return app.realCity.name;
                }

                /**
                 * @protected
                 */

            }, {
                key: "checkLocation",
                value: function checkLocation() {
                    var _this3 = this;

                    if (this.isLocatedUser()) {
                        this.fitSiteToCity(app.city.id, true);
                        // fb counter
                        this.initializePixel(app.realCity.name);
                    } else {
                        window.addEventListener('load', function () {
                            if (window.app.isGeolocationEnabled) {
                                location.get(function (locatedCityName) {
                                    _this3.setCity(locatedCityName, true, true);
                                    _this3.onCheckLocation(locatedCityName);
                                });
                            } else {
                                _this3.onCheckLocation('');
                            }
                        }, { once: true });
                    }
                }

                /**
                 * @param {string} locatedCityName
                 * @private
                 */

            }, {
                key: "onCheckLocation",
                value: function onCheckLocation(locatedCityName) {
                    // fb counter
                    this.initializePixel(locatedCityName);

                    // let detectedCity =
                    //     locatedCityName !== '' ? window.CityItem.findByName(locatedCityName) : null;
                    // if (!detectedCity) {
                    //     detectedCity =  window.CityItem.getDefault();
                    // }

                    // this.showDetectedCityConfirm(detectedCity.id);
                }

                /**
                 * @param {string} cityName
                 * @param {boolean} isReal
                 * @param {boolean} runCallback
                 */

            }, {
                key: "setCity",
                value: function setCity(cityName, isReal) {
                    var _this4 = this;

                    var runCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

                    // Если менять то все свойства app.city сразу (несовпадение app.city.id и app.city.name)
                    // app.city.name = cityName;
                    if (isReal) {
                        app.realCity.name = cityName;
                    }
                    $.post(app.urls.setCity, {
                        city: cityName,
                        real: isReal ? 1 : ''
                    }, function (data) {
                        if (runCallback) {
                            if (data.city) {
                                app.city = data.city;
                                _this4.onAfterSetCity();
                            }
                        }
                    }, 'json');
                }
            }, {
                key: "onAfterSetCity",
                value: function onAfterSetCity() {}
            }, {
                key: "initializePixel",
                value: function initializePixel(realCityName) {
                    if (!pixelTracker.exists(realCityName)) {
                        realCityName = window.CityItem.getDefault().name;
                    }
                    pixelTracker.init(realCityName);
                }
            }]);

            return BaseCitySelect;
        }();

        module.exports = BaseCitySelect;
    }, { "./CityItem": 3, "./Location": 4, "./PixelTracker": 5 }], 3: [function (require, module, exports) {
        var CITY_ALMATY = 1;

        var TYPE_CURRENT = 'current';
        var TYPE_ALT = 'alt';

        var CityItem = function () {
            function CityItem(city) {
                _classCallCheck(this, CityItem);

                /** @type {number} */
                this.id = Number(city.id);

                /** @type {string} */
                this.name = city.name;

                /** @type {number|null} */
                this.depart_id = city.depart_id ? Number(city.depart_id) : null;

                /**
                 * @type {{code: string, phone: string, href: string, clearPhone: string}}
                 */
                this.currentPhone = {
                    code: city.currentPhone.code,
                    phone: city.currentPhone.phone,
                    clearPhone: city.currentPhone.clearPhone,
                    href: city.currentPhone.href
                };
                this.currentPhone.linkHtml = CityItem._getPhoneLinkHtml(this.currentPhone.phone, this.currentPhone.href, this.currentPhone.clearPhone);
                this.currentPhone.hiddenHtml = CityItem._getHiddenPhoneHtml(this.currentPhone.code, this.id, TYPE_CURRENT);

                /**
                 * @type {{code: string, phone: string, href: string, clearPhone: string}}
                 */
                this.altPhone = {
                    code: city.altPhone.code,
                    phone: city.altPhone.phone,
                    clearPhone: city.altPhone.clearPhone,
                    href: city.altPhone.href
                };
                this.altPhone.linkHtml = CityItem._getPhoneLinkHtml(this.altPhone.phone, this.altPhone.href, this.altPhone.clearPhone);
                this.altPhone.hiddenHtml = CityItem._getHiddenPhoneHtml(this.altPhone.code, this.id, TYPE_ALT);

                /**
                 * @type {{instagram: string, facebook: string}}
                 */
                this.socials = {
                    instagram: city.socials.instagram,
                    facebook: city.socials.facebook
                };

                this.contactsHidden = city.contactsHidden;
            }

            // Использовать этот метод если нужен вывод номера без скрытия


            _createClass(CityItem, [{
                key: "getPhoneAsLink",
                value: function getPhoneAsLink(type) {
                    return type === TYPE_ALT ? this.altPhone.linkHtml : this.currentPhone.linkHtml;
                }
            }, {
                key: "getPhoneView",
                value: function getPhoneView(type) {
                    return type === TYPE_ALT ? this.getAltPhoneView() : this.getCurrentPhoneView();
                }
            }, {
                key: "getCurrentPhoneView",
                value: function getCurrentPhoneView() {
                    return this.contactsHidden ? this.currentPhone.hiddenHtml : this.currentPhone.linkHtml;
                }
            }, {
                key: "getAltPhoneView",
                value: function getAltPhoneView() {
                    return this.contactsHidden ? this.altPhone.hiddenHtml : this.altPhone.linkHtml;
                }
            }], [{
                key: "_getHiddenPhoneHtml",
                value: function _getHiddenPhoneHtml(phoneCode, cityId, type) {
                    return CityItem._template(window.app.cityTemplate.hiddenPhone, { phoneCode: phoneCode, cityId: cityId, type: type });
                }
            }, {
                key: "_getPhoneLinkHtml",
                value: function _getPhoneLinkHtml(phone, href, clearPhone) {
                    return CityItem._template(window.app.cityTemplate.phoneLink, { phone: phone, href: href, clearPhone: clearPhone });
                }

                /**
                 * @param {string} template
                 * @param {{}} values
                 * @return {*}
                 * @private
                 */

            }, {
                key: "_template",
                value: function _template(template, values) {
                    for (var key in values) {
                        template = template.split('{{' + key + '}}').join(values[key]);
                    }

                    return template;
                }

                /**
                 * @private
                 * @param {string} field
                 * @param {number|string} value
                 * @return {CityItem|null}
                 */

            }, {
                key: "_findByField",
                value: function _findByField(field, value) {
                    var city = null;
                    for (var i in app.cities) {
                        if (value === app.cities[i][field]) {
                            city = new CityItem(app.cities[i]);
                            break;
                        }
                    }

                    return city;
                }

                /**
                 * @param {number} cityId
                 * @return {boolean}
                 */

            }, {
                key: "contactExist",
                value: function contactExist(cityId) {
                    return 'undefined' !== typeof app.cities[cityId];
                }

                /**
                 * @param {string} cityName
                 * @return {CityItem|null}
                 */

            }, {
                key: "findByName",
                value: function findByName(cityName) {
                    return CityItem._findByField('name', cityName);
                }

                /**
                 * @param {number} departId
                 * @return {CityItem|null}
                 */

            }, {
                key: "findByDepartId",
                value: function findByDepartId(departId) {
                    return CityItem._findByField('depart_id', departId);
                }

                /**
                 * @param {number} cityId
                 * @return {CityItem|null}
                 */

            }, {
                key: "findById",
                value: function findById(cityId) {
                    return this.contactExist(cityId) ? new CityItem(app.cities[cityId]) : null;
                }

                /**
                 * Возвращает текущий город
                 * @return {CityItem}
                 */

            }, {
                key: "getCurrent",
                value: function getCurrent() {
                    var cityItem = null;
                    if (app.city && this.contactExist(app.city.id)) {
                        var city = this.findById(app.city.id);
                        cityItem = new CityItem(city);
                    }

                    if (cityItem === null) {
                        cityItem = this.getDefault();
                    }

                    return cityItem;
                }

                /**
                 * Возвращает город по умолчанию
                 * @return {CityItem}
                 */

            }, {
                key: "getDefault",
                value: function getDefault() {
                    return this.findById(CITY_ALMATY);
                }
            }]);

            return CityItem;
        }();

        module.exports = CityItem;
    }, {}], 4: [function (require, module, exports) {
        var Location = function () {
            function Location() {
                _classCallCheck(this, Location);

                this.locatedCity = null;
            }

            /**
             * @param {function} callback
             */


            _createClass(Location, [{
                key: "get",
                value: function get(callback) {
                    var _this5 = this;

                    window.ymapGeolocationLoader.load(function () {
                        if (typeof ymaps === 'undefined' || !ymaps.geolocation) {
                            console.log('ymaps undefined, geolocation off');
                        } else if (_this5.locatedCity !== null) {
                            callback(_this5.locatedCity);
                        } else {
                            var self = _this5;
                            ymaps.ready(function () {
                                ymaps.geolocation.get({ provider: 'yandex' }).then(function (result) {
                                    var locatedCity = result.geoObjects.get(0).properties.get('name');
                                    if (locatedCity === 'Нур-Султан (Астана)') {
                                        locatedCity = 'Астана';
                                    }
                                    console.log('geo', locatedCity);
                                    self.locatedCity = locatedCity;

                                    callback(self.locatedCity);
                                });
                            });
                        }
                    });
                }
            }]);

            return Location;
        }();

        module.exports = new Location();
    }, {}], 5: [function (require, module, exports) {
        var PixelTracker = function () {
            function PixelTracker() {
                _classCallCheck(this, PixelTracker);

                this.isInitialized = false;
            }

            /**
             * @param {string} realCityName
             * @return {boolean}
             */


            _createClass(PixelTracker, [{
                key: "init",
                value: function init(realCityName) {
                    if (this.isInitialized) {
                        return false;
                    }

                    var pixelId = this.getId(realCityName);
                    if (pixelId !== '') {
                        this.isInitialized = true;
                        !function (f, b, e, v, n, t, s) {
                            if (f.fbq) {
                                return;
                            }
                            n = f.fbq = function () {
                                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                            };
                            if (!f._fbq) f._fbq = n;
                            n.push = n;
                            n.loaded = !0;
                            n.version = '2.0';
                            n.queue = [];
                            t = b.createElement(e);
                            t.async = !0;
                            t.src = v;
                            s = b.getElementsByTagName(e)[0];
                            s.parentNode.insertBefore(t, s);
                        }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
                        fbq('init', pixelId); // Insert your pixel ID here.
                        fbq('track', 'PageView');
                    }

                    var srcId = null;
                    if (window.app.updateSourceId !== undefined) {
                        srcId = window.app.updateSourceId;
                    } else if (!document.referrer) {
                        srcId = 33;
                    }
                    if (srcId !== null) {
                        $.get('/site/updateCounter', {
                            src_id: srcId,
                            city_id: window.app.city.id
                        });
                    }

                    return true;
                }

                /**
                 * @param {string} realCityName
                 * @return {string}
                 */

            }, {
                key: "getId",
                value: function getId(realCityName) {
                    var pixelId = '';
                    switch (realCityName) {
                        case 'Алматы':
                            //
                            pixelId = '';
                            break;
                        case 'Астана':
                        case 'Нур-Султан (Астана)':
                            pixelId = '';
                            break;
                        case 'Актобе':
                            //
                            pixelId = '';
                            break;
                    }

                    return pixelId;
                }

                /**
                 * @param {string} realCityName
                 * @return {boolean}
                 */

            }, {
                key: "exists",
                value: function exists(realCityName) {
                    return this.getId(realCityName) !== '';
                }
            }]);

            return PixelTracker;
        }();

        module.exports = new PixelTracker();
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /**
         * Created by vikf on 16.10.15.
         */
        var new_short_id = true;

        $(document).ready(function () {
            //cool select
            var $body = $("body");
            var $currencySelect = false;

            if (moment) {
                moment.locale('ru');
            }

            initPhoneMask();

            $currencySelect = new hSelect({
                selector: '#hSelectCurrency',
                theme: 'main',
                checkWidth: false,
                onChange: function onChange(ui) {
                    $.post(app.urls.setCurrency, { currency: ui.value }).done(function (response) {
                        window.location.reload();
                    });
                }
            });

            function handlers() {

                $('.js-slide-to').on('click', function (e) {
                    e.preventDefault();
                    var targetSelector = $(this).data('target');
                    var $target = $(targetSelector);
                    if ($target.length) {
                        $('html, body').animate({
                            scrollTop: $target.offset().top - 10
                        }, 1000);
                    }
                });

                $('.filters-item .item-toggle').on('click', function (e) {
                    $(this).parent().toggleClass('open');
                });

                $body.on('click', '.show-subscribe-popup', function (e) {
                    e.preventDefault();
                    var $popup = $('#bspopup');
                    var url = '/subscription/form.html';
                    var $body = $popup.find('.modal-body');
                    var $content = $popup.find('.modal-content');

                    $popup.addClass('request-helper');
                    $body.css('height', 'auto');
                    $content.addClass('transparent');
                    $body.html('<p class="text-center"><img src="/img/load.gif" /></p>');
                    $popup.addClass('subscribe-close').removeClass('success-close request-close');
                    $popup.modal({
                        backdrop: true,
                        show: true
                    });
                    $.get(url, {}, function (data) {
                        $body.html(data);
                    });
                }).on('click', '#onesignal-popover-allow-button', function () {
                    window.tracking.setEvent('push-yes.Click');
                }).on('click', '#onesignal-popover-cancel-button', function () {
                    window.tracking.setEvent('push-no.Click');
                }).on('click', '.js-popup', function (e) {
                    e.preventDefault();
                    return false;
                }).on('click', '.popup', function (e) {
                    e.preventDefault();
                    var link = '',
                        t = $(this);
                    if (t.attr('data-href')) link = t.attr('data-href');else link = t.attr('alt');
                    bs3popup({
                        page_url: link,
                        width: t.data('width') ? t.data('width') : t.attr('rel'),
                        hash: t.data('hash'),
                        data: t.data(),
                        setLock: true
                    });
                }).on('click', '.close_popup', close_popup).on('click', '.menu .btn-menu', function (e) {
                    e.preventDefault();
                    $(this).closest('.menu').toggleClass('open');
                }).on('click', '.hidden-phone', function (e) {
                    e.preventDefault();
                    var $self = $(this);
                    var city = window.CityItem.findById($self.data('city'));
                    $self.replaceWith(city.getPhoneAsLink($self.data('type')));
                    window.tracking.setEvent('hiddenPhone.click');
                }).on('click', '.clickable-phone', function () {
                    window.tracking.setEvent('sitePhone.click');
                }).on('click', '.analytic-event', function () {
                    var event = $(this).data('event');
                    window.tracking.setEvent(event);
                })
                // При закрытии модального окна очищаем созданные объекты карт
                // Работает для всплывашек схемы проезда и всплывашек с инфо об отеле
                .on('hidden.bs.modal', '#bspopup', function (e) {
                    new_short_id = true;
                }).on('click', '.tour_tab_link', function () {
                    $('#formCalendar div.month-picture div.month-title_wrapper').hide();
                    $('#tours-preloader .preloader-span').html('Пожалуйста, подождите. Идёт загрузка');
                    $('#tours-preloader').show();
                });
            }

            $('ul.nav li.dropdown').hover(function (e) {
                $(this).find('.dropdown-menu').stop(true, true).delay(40).fadeIn(1);
            }, function () {
                $(this).find('.dropdown-menu').stop(true, true).delay(40).hide();
            });

            handlers();
        });
    }, {}] }, {}, [1]);